-<template>

  <div v-if="singleStoryDetail != null" class="maxwidth pt-10 pb-10">

    <v-carousel
      v-if="singleStoryDetail.cover_image!=null&&(singleStoryDetail.KGArrayImg!=null&&singleStoryDetail.KGArrayImg.length>0)||(singleStoryDetail.images!=null&&singleStoryDetail.images.length>0)"
      class="parent" height="auto" :show-arrows="false">
      <v-carousel-item>
        <template>
          <template v-if="singleStoryDetail.cover_image!=null">
            <mediaFileStory
              v-if="!$vuetify.breakpoint.mdAndUp&&singleStoryDetail.cover_image.media.formats.hasOwnProperty('large')"
              :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.large.url.replace(/ /g, '%20')"
              type="image" :isLocal="false" :storyTitle="singleStoryDetail.title">
            </mediaFileStory>
            <mediaFileStory
              v-else-if="!$vuetify.breakpoint.mdAndDown&&singleStoryDetail.cover_image.media.formats.hasOwnProperty('medium')"
              :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.medium.url.replace(/ /g, '%20')"
              type="image" :isLocal="false" :storyTitle="singleStoryDetail.title">
            </mediaFileStory>
            <mediaFileStory
              v-else-if="!$vuetify.breakpoint.mdAndDown&&singleStoryDetail.cover_image.media.formats.hasOwnProperty('small')"
              :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.small.url.replace(/ /g, '%20')"
              type="image" :isLocal="false" :storyTitle="singleStoryDetail.title">
            </mediaFileStory>
            <mediaFileStory v-else
              :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.thumbnail.url.replace(/ /g, '%20')"
              type="image" :storyTitle="singleStoryDetail.titleStory" :isLocal="false">
            </mediaFileStory>
          </template>
          <template v-else>
            <v-img class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
          </template>
        </template>
      </v-carousel-item>
      <v-carousel-item v-for="singleImages in singleStoryDetail.images" :key="singleImages.id">
        <template>

          <mediaFileStory v-if="!$vuetify.breakpoint.mdAndUp&&singleImages.media.formats.hasOwnProperty('large')"
            :mediaUrl="apiStrapi + singleImages.media.formats.large.url.replace(/ /g, '%20')" type="image"
            :isLocal="false" :storyTitle="singleStoryDetail.title">
          </mediaFileStory>
          <mediaFileStory
            v-else-if="!$vuetify.breakpoint.mdAndDown&&singleImages.media.formats.hasOwnProperty('medium')"
            :mediaUrl="apiStrapi + singleImages.media.formats.medium.url.replace(/ /g, '%20')" type="image"
            :isLocal="false" :storyTitle="singleStoryDetail.title">
          </mediaFileStory>
          <mediaFileStory v-else-if="!$vuetify.breakpoint.mdAndDown&&singleImages.media.formats.hasOwnProperty('small')"
            :mediaUrl="apiStrapi + singleImages.media.formats.small.url.replace(/ /g, '%20')" type="image"
            :isLocal="false" :storyTitle="singleStoryDetail.title">
          </mediaFileStory>
          <mediaFileStory v-else :mediaUrl="apiStrapi + singleImages.media.formats.thumbnail.url.replace(/ /g, '%20')"
            type="image" :storyTitle="singleStoryDetail.titleStory" :isLocal="false">
          </mediaFileStory>
        </template>


      </v-carousel-item>
      <v-carousel-item v-for="singleKGimages in singleStoryDetail.KGArrayImg" :key="singleKGimages.id">
        <template>
          <v-img :contain="true" :src="singleKGimages.image" />
        </template>
      </v-carousel-item>
    </v-carousel>
    <template v-else>
      <template v-if="singleStoryDetail.cover_image!=null">
        <mediaFileStory
          v-if="!$vuetify.breakpoint.mdAndUp&&singleStoryDetail.cover_image.media.formats.hasOwnProperty('large')"
          :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.large.url.replace(/ /g, '%20')"
          type="image" :isLocal="false" :storyTitle="singleStoryDetail.title">
        </mediaFileStory>
        <mediaFileStory
          v-else-if="!$vuetify.breakpoint.mdAndDown&&singleStoryDetail.cover_image.media.formats.hasOwnProperty('medium')"
          :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.medium.url.replace(/ /g, '%20')"
          type="image" :isLocal="false" :storyTitle="singleStoryDetail.title">
        </mediaFileStory>
        <mediaFileStory
          v-else-if="!$vuetify.breakpoint.mdAndDown&&singleStoryDetail.cover_image.media.formats.hasOwnProperty('small')"
          :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.small.url.replace(/ /g, '%20')"
          type="image" :isLocal="false" :storyTitle="singleStoryDetail.title">
        </mediaFileStory>
        <mediaFileStory v-else
          :mediaUrl="apiStrapi + singleStoryDetail.cover_image.media.formats.thumbnail.url.replace(/ /g, '%20')"
          type="image" :storyTitle="singleStoryDetail.titleStory" :isLocal="false">
        </mediaFileStory>
      </template>
      <template v-else>
        <v-img class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
      </template>
    </template>
    <!-- v-if="connectedStory>0" v-if="similarStories && similarStories.length>0"-->
    <v-img v-if="isKGenable=='true'&& (connectedStory.length>0 || similarStories.length>0)" contain
      @click="gotoSingleStoryKGView()" class="connectednessIcon"
      style="width:200px;position:absolute;top:1.5rem;right:-3rem" :src="require('@/assets/connectedness.png')"></v-img>
<template v-if="isKGenable=='true'&& (connectedStory.length>0 || similarStories.length>0)" >
      <v-icon style="width:200px;position:absolute;top:10rem;right:-3rem" v-if="isTooltipConnectedness" contain
      @click="toggleinformation()"  color=primary
      >mdi-information</v-icon>
            <v-icon v-else contain  style="width:200px;position:absolute;top:10rem;right:-3rem"
      @click="toggleinformation()"  color=white
      >mdi-information</v-icon>
<div v-if="isTooltipConnectedness" style="border-radius:10px;padding:5px;width:200px;position:absolute;top:12rem;right:2rem;color:black;background-image:linear-gradient(to right, #E5FFFF , #81B9BF);"> {{$t("tooltipConnectedness")}}</div>
</template>
    <v-row class="px-10">

      <!--v-col cols="6" v-if="singleStoryDetail.tags">
            <span v-for="tag in singleStoryDetail.tags" :key="tag.tag">
              <v-chip class="mr-2 mb-1">{{$t(tag.tag)}}</v-chip>
            </span>
          </v-col-->

      <v-col cols="12">
        <div style="text-align:right">
          <template v-if="typeof(singleStoryDetail.attachments)!='undefined'&&singleStoryDetail.attachments.length>0">
            <v-btn class="ml-1 text--primary" color="secondaryVariant" small left fab
              @click.stop="dialogattachments = true">
              <v-icon style="transform:rotate(270deg);">mdi-attachment</v-icon>
            </v-btn>
            <v-dialog v-model="dialogattachments" :fullscreen="true">
              <v-card>
                <v-container class="pt-0 pb-0">
                  <v-row justify="end">
                    <v-col cols=10>
                      <span class="memexStoryTitle">{{singleStoryDetail.title}}</span>
                    </v-col>
                    <v-col cols=2>
                      <v-btn color="red darken-3" text @click="dialogattachments = false" :icon="true">
                        <i class="big mdi mdi-close"></i>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-title class="headline">
                </v-card-title>
                <v-card-text>
                  <mediaFileStory v-for="(singleattachment,index) in singleStoryDetail.attachments"
                    :key="singleattachment.id" :mediaUrl="apiStrapi + singleattachment.media.url.replace(/ /g, '%20')"
                    type="attachment"
                    :mediaFileTitle="$t('upload_attachment')+(' ')+(index +1)/*singleattachment.title*/"
                    :storyTitle="singleStoryDetail.title" :isLocal="false" />
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
          <template v-if="singleStoryDetail.video!=null">
            <v-btn class="ml-1 text--primary" color="secondaryVariant" small right fab @click.stop="openVideo">
              <v-icon>mdi-play-box-multiple-outline</v-icon>
            </v-btn>
            <v-dialog v-model="dialogvideo" :fullscreen="true">
              <v-card>
                <v-container class="pt-0 pb-0">
                  <v-row justify="end">
                    <v-col cols=10>
                      <span class="memexStoryTitle">{{singleStoryDetail.title}}</span>
                    </v-col>
                    <v-col cols=2>
                      <v-btn color="red darken-3" text @click="closeVideo" :icon="true">
                        <i class="big mdi mdi-close"></i>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-title class="headline">
                </v-card-title>
                <v-card-text>
                  <mediaFileStory :mediaUrl="apiStrapi + singleStoryDetail.video.media.url.replace(/ /g, '%20')"
                    type="video" :mediaFileTitle="$t('upload_video')/*singleStoryDetail.video.title*/"
                    :storyTitle="singleStoryDetail.title" :isLocal="false" />
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>

          <template>
            <v-btn v-if="typeof(singleStoryDetail.audios)!='undefined'&&singleStoryDetail.audios.length>0"
              class="ml-1 text--primary" color="secondaryVariant" small left fab @click.stop="openAudio">
              <v-icon>mdi-music-note-outline</v-icon>
            </v-btn>
            <v-dialog v-model="dialogaudio" :fullscreen="true">
              <v-card>
                <v-container class="pt-0 pb-0">
                  <v-row align="center" justify="end">
                    <v-col cols=10>
                      <span class="memexStoryTitle">{{singleStoryDetail.title}}</span>
                    </v-col>
                    <v-col cols=2>
                      <v-btn color="red darken-3" text @click="closeAudio" :icon="true">
                        <i class="big mdi mdi-close"></i>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-title class="headline">
                </v-card-title>
                <v-card-text v-if="singleStoryDetail.audios!=[]">
                  <mediaFileStory v-for="(singleAudio,index) in singleStoryDetail.audios" :key="singleAudio.id"
                    :mediaUrl="apiStrapi + singleAudio.media.url.replace(/ /g, '%20')" type="audio"
                    :mediaFileTitle="(index +1) +('. ')+ $t('upload_audio')" :storyTitle="singleStoryDetail.title"
                    :isLocal="false" />
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </div>
      </v-col>

      <v-col cols=12 class="mt-0 pt-0 mb-0 pb-0">
        <span class="titleStory">{{singleStoryDetail.title}}</span>
      </v-col>
      <!--v-btn icon fab absolute left>
        <i class="mdi mdi-checkbox-blank-circle"></i>
      </v-btn-->
      <v-col align="left" cols=12 class="mt-1 mb-1 pt-0 mb-0 pb-0 mx-0 px-0">
        <v-btn v-if="positionOnMap!=null" class="mt-0 mb-0 pt-0 mb-0 pb-0 mx-2 px-0" @click="gotoSingleStoryMapView()"
          text color="darkblue">
          <span class="placeNameSyle">
            <v-icon class="mr-2">mdi-map-marker</v-icon>{{truncate(this.positionOnMap.data.info,50)}}
          </span>
        </v-btn>
        <!--singleStoryDetail.user.id==getUser.id&&(readOnly!=='true')-->
        <v-btn v-if="singleStoryDetail.user.id&&getUser.username!='Guest'" :style="isCreateJourneyOpen?'white-space: nowrap;width:fit-content;position:fixed;bottom:25vh;right:2vh;padding:1rem;border-radius:99rem':'position:fixed;bottom:25vh;right:2vh'" fab  @click="isCreateJourneyOpen=!isCreateJourneyOpen" left :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly" color="secondaryVariant" >
          <i style="font-size:2.3rem" class="mdi mdi-sign-direction black--text"></i>
          <v-expand-x-transition style="white-space: nowrap">
            <span class="black--text" v-if="isCreateJourneyOpen" @click="createNewJourney()" >{{$t('createNewJourney')}}</span>
          </v-expand-x-transition>
        </v-btn>
        <v-btn v-if="singleStoryDetail.user.id!=null&&getUser.username!='Guest'" :style="isEditJourneyOpen?'white-space: nowrap;width:fit-content;position:fixed;bottom:15vh;right:2vh;padding:1rem;border-radius:99rem':'white-space: nowrap;position:fixed;bottom:15vh;right:2vh'" fab  @click="isEditJourneyOpen=!isEditJourneyOpen" left :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly" color="secondaryVariant">
          <i style="font-size:2.3rem" class="mdi mdi-sign-direction-plus black--text"></i>
          <v-expand-x-transition style="white-space: nowrap">
            <span class="black--text" v-if="isEditJourneyOpen" @click="addStoryToJourney()" >{{$t('addToJourney')}}</span>
          </v-expand-x-transition>
        </v-btn>

      </v-col>



      <v-col v-if="IsJsonString(singleStoryDetail.content)" :class="'minheightcontent contentpreview '" cols="12">
        <span v-for="(element,index) in JSON.parse(singleStoryDetail.content)" :key="index" v-html="element.data">

        </span>
      </v-col>

      <v-col v-else :class="'minheightcontent contentpreview'+ classContent(singleStoryDetail.user.id)"
        v-html="singleStoryDetail.content" cols="12">
      </v-col>
              <v-col cols="12" v-if="singleStoryDetail.tags.length>0">
                <span v-for="tag in singleStoryDetail.tags" :key="tag.tag">
                  <v-chip class="mr-2 mb-1 grey lighten-3 black--text">{{$t(tag.tag)}}</v-chip>
                </span>
              </v-col>

    </v-row>
    <template v-if="IsJsonString(singleStoryDetail.content)&&JSON.parse(singleStoryDetail.content).length>1"
      :class="'contentpreview '+ classContent(singleStoryDetail.user.id)">
      <span>
        <v-row  class="grey lighten-3 px-5 pb-5" style="min-height:12vh">
          <v-col v-if="IsJsonString(singleStoryDetail.content)&&JSON.parse(singleStoryDetail.content).length>1"
            cols="12" style="mb-5"><strong>{{ $t("Sources")}}</strong></v-col>
          <v-col cols="12" class="px-3 mx-3 pt-0 pb-0 mt-0 mb-0">
            <ol>
              <span v-for="(element,index) in JSON.parse(singleStoryDetail.content)" :key="index">
                <li v-if="element.type=='quote'">
                  <a :href="element.url">{{element.url}} </a>
                </li>
              </span>
            </ol>
          </v-col>
        </v-row>
      </span>
    </template>

    <template v-if="singleStoryDetail.stages.length==1">



    <v-container  class="black white--text px-3"  >
      <v-row align="center" >
        <v-col align="center">
        {{$t('ThisStoryIsPartOfThisJourney')}}
        </v-col>
</v-row>
<v-row align="center" @click="goToJourney(singleStoryDetail.stages[0].journey)" class="px-0 mt-0 mx-0 px-0" :class="'colorPalettejourney'+singleStoryDetail.stages[0].backgroundColor+''">
    <v-col class="px-0 pt-0 pb-0 mt-0 mx-0 px-0" cols="4">
                        <mediaFileStory
              v-if="singleStoryDetail.stages[0].cover_image.media.formats.hasOwnProperty('small')"
              :mediaUrl="apiStrapi + singleStoryDetail.stages[0].cover_image.media.formats.small.url.replace(/ /g, '%20')"
              type="image" :isLocal="false" :storyTitle="singleStoryDetail.stages[0].title">
            </mediaFileStory>
                  <mediaFileStory
              v-else-if="singleStoryDetail.stages[0].cover_image.media.formats.hasOwnProperty('thumbnail')"
              :mediaUrl="apiStrapi + singleStoryDetail.stages[0].cover_image.media.formats.thumbnail.url.replace(/ /g, '%20')"
              type="image" :isLocal="false" :storyTitle="singleStoryDetail.stages[0].title">
            </mediaFileStory>
      </v-col>
  <v-col class="px-0 mt-0 mx-0 px-4" cols="8"><strong>{{singleStoryDetail.stages[0].journeyTitle}}</strong><br/>
  {{truncate(singleStoryDetail.stages[0].journeyShortDescription,60)}}</v-col>
</v-row>
    </v-container>


    </template>
    <template v-else-if="singleStoryDetail.stages.length>1">

  <v-carousel height="auto" :hide-delimiters="true">
    <v-carousel-item
      v-for="(singleJourney, i) in singleStoryDetail.stages"
      :key="i" class="black white--text" 
    >
    <v-container  class="black white--text px-3"  >
      <v-row align="center" >
        <v-col align="center">
        {{$t('ThisStoryIsPartOfTheseJourney')}}
        </v-col>
</v-row>
<v-row align="center" @click="goToJourney(singleJourney.journey)" class="px-0 mt-0 mx-0 px-0" :class="'colorPalettejourney'+singleJourney.backgroundColor+''">
    <v-col class="px-0 pt-0 pb-0 mt-0 mx-0 px-0" cols="4">
                        <mediaFileStory
              v-if="singleJourney.cover_image.media.formats.hasOwnProperty('small')"
              :mediaUrl="apiStrapi + singleJourney.cover_image.media.formats.small.url.replace(/ /g, '%20')"
              type="image" :isLocal="false" :storyTitle="singleJourney.title">
            </mediaFileStory>
                  <mediaFileStory
              v-else-if="singleJourney.cover_image.media.formats.hasOwnProperty('thumbnail')"
              :mediaUrl="apiStrapi + singleJourney.cover_image.media.formats.thumbnail.url.replace(/ /g, '%20')"
              type="image" :isLocal="false" :storyTitle="singleJourney.title">
            </mediaFileStory>
      </v-col>
  <v-col class="px-0 mt-0 mx-0 px-4" cols="8"><strong>{{singleJourney.journeyTitle}}</strong><br/>
  {{truncate(singleJourney.journeyShortDescription,60)}}</v-col>
</v-row>
    </v-container>
    </v-carousel-item>
  </v-carousel>

    </template>

    <template v-if="singleStoryDetail.user.id!=null&&(readOnly!=='true')&&singleStoryDetail.user.id==getUser.id">
      <v-row>
        <v-col class="text-center" cols="6">
          <deleteEditStory :singleStory="singleStoryDetail" :isDeleteBtn="false" />
        </v-col>
        <v-col class="text-center" cols="6">
          <deleteEditStory :storyID="parseInt(singleStoryDetail.id)" :isDeleteBtn="true" />
        </v-col>
      </v-row>
    </template>

  </div>

</template>

<script>
import mediaFileStory from "@/components/mediaFileStory.vue";
import deleteEditStory from "@/components/deleteEditStory.vue";
import dialogMixin from "vue-dialog-mixin"

export default {
  name: 'singleStoryView',
  mixins: [dialogMixin],
  data() {
    return {
      isTooltipConnectedness:true,
      isEditJourneyOpen:false,
      isCreateJourneyOpen:false,
      readOnly: process.env.VUE_APP_READONLY,
      isKGenable: process.env.VUE_APP_ISKGENABLE,
      connectedStory: [],
      connectedHeritages: [],
      apiUrl: process.env.VUE_APP_ROOT_API,
      //all the information of the selected story
      singleStoryDetail: null,
      dialogaudio: false,
      dialogvideo: false,
      isDialogMediaPlayerClose: null,
      dialogattachments: false,
      apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
      item: null,
      positionOnMap: null,
      similarStories: [],
      stages: []

    }
  },
  watch: {
    singleStoryID(val) {
      this.reMountcomponent(val);
    }
  },
  async mounted() {
    this.reMountcomponent();

  },
  methods: {
toggleinformation(){
  this.isTooltipConnectedness=!this.isTooltipConnectedness
}

,
  async reMountcomponent() {
        this.$store.dispatch('setSelectedSingleStoryID', this.$route.query.idStory)
    //console.log("singleStoryView",this.$route.query.IDOftheStoryDetail)
    //console.log("getSelectStoryConnectionsToStories")
    await this.getSelectStoryConnectionsToStories()
    await this.getSelectStoryHeritageConnections()
    await this.getSingleStory()
    //await this.getConnectednessStory();
    this.positionOnMap = await this.retrivePositionMarkerPlace()
    // when the position is not defined , must be set to ""
    //set title
    //set position on the map
    this.$store.dispatch("setSelectedSingleStory", this.singleStoryDetail)

    //to remove ---------------
    this.$store.dispatch("setSingleStoryTitle", this.singleStoryDetail.title)
    this.$store.dispatch("setSingleStoryTags", this.singleStoryDetail.tags)
    this.$store.dispatch("setSingleStoryPositionOnMap", this.positionOnMap.data.info)
    this.$store.dispatch("setSingleStoryGeolocalizationOnMap", {
      lat: this.singleStoryDetail.latitude,
      lng: this.singleStoryDetail.longitude
    })
      },
      goToJourney(idJourney){
        this.$router.push({name:'singleJourneyView',query:{'idJourney':idJourney}})
      },
    async getSelectStoryHeritageConnections() {
      try {
        //console.log("getSelectStoryHeritageConnections")

        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getStoryConnections?story_id=' + this.$route.query.idStory + '&short=100&limit=100&language='+this.$vuetify.lang.current

        this.getaxiosResponse(completeurl).then(response => {
          this.connectedHeritages = response.data
        })

        this.$store.dispatch('setLoading', false)

      } catch (error) {
        console.log(error);
        if (error.status === 500) {
          this.connectedHeritages = []
        }
      }
    },
    async getSelectStoryConnectionsToStories() {
      try {
        //console.log("getSelectStoryConnectionsToStories")

        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getSimilarStories?story_id=' + this.$route.query.idStory + '&short=100&limit=100'

        this.getaxiosResponse(completeurl).then(response => {
          if (response.data.length > 0) {
            this.connectedStory = response.data
          }
        })
        //push selected story in array of connected stories as first element
        //this.connectedStory.unshift(this.selectedSingleStory)

        this.$store.dispatch('setLoading', false)
      } catch (error) {
        if (error.status === 500) {

          this.connectedStory = []
        }
        console.log(error);
      }
    },

    IsJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },

    //truncate string
    truncate(str, n) {
      return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
    },
    openAudio() {
      this.$store.dispatch('setIsDialogMediaPlayerClosed', false).then(() => this.dialogaudio = true)
    },
    openVideo() {
      this.$store.dispatch('setIsDialogMediaPlayerClosed', false).then(() => this.dialogvideo = true)
    },
    closeVideo() {
      this.$store.dispatch('setIsDialogMediaPlayerClosed', true).then(() => this.dialogvideo = false)
    },
    closeAudio() {
      this.$store.dispatch('setIsDialogMediaPlayerClosed', true).then(() => this.dialogaudio = false)
    },
    //retrive the address position - for header
    retrivePositionMarkerPlace: async function () {
      try {
        return this.getaxiosResponse(this.apiUrl + '/getGeoLocationInfo?lat=' + this.singleStoryDetail.latitude + '&lon=' + this.singleStoryDetail.longitude)
      } catch (error) {
        if (error.status === 400) {
          // Handle error.
        }
        // Handle error.
        else {
          console.log(error);
        }
      }
    },
    createNewJourney:function(){
      this.$store.dispatch('clearNewJourney')
        this.$router.push({
          'name': 'createNewJourneyContent',
          'query':{idStory:this.$route.query.idStory}
        })
      }
    ,
    addStoryToJourney:function(){
      this.$store.dispatch('clearNewJourney')
        this.$router.push({
          'name': 'addStoryInJourney',
          'query':{idStory:this.$route.query.idStory}
        })
      }
    ,
    gotopage: function (page) {
      if (this.$route.name != page) {
        this.$router.push({
          'name': page,
          'query':{idStory:this.$route.query.idStory}
        })
      }
    },
    gotoSingleStoryMapView: function () {
      this.$router.push({
        'name': 'singleStoryMapView'
      })
    },
    //
    gotoSingleStoryKGView: function () {
      this.$router.push({
        'name': 'singleStoryKGView'
      })
    },

    classContent: function (storyUserId) {
      if (this.getUser.id == storyUserId)
        return 'mb-15 pb-15'
      else
        return ''
    },
        async getSingleJourney(journeyID) {
      try {


        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getJourney?id=' + journeyID
        let tempSingleJourneyDetail
        tempSingleJourneyDetail = await this.getaxiosResponse(completeurl)
        if (typeof tempSingleJourneyDetail.content == "string") {
          tempSingleJourneyDetail.content = JSON.parse(tempSingleJourneyDetail.content)
        }
        return tempSingleJourneyDetail.data

      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },

    async getSingleStory() {
      try {
        //console.log("getSingleStory")

        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getSingleStory?id=' + this.$route.query.idStory
        let tempSingleStoryDetail
        tempSingleStoryDetail = await this.getaxiosResponse(completeurl)
        if (typeof tempSingleStoryDetail.content == "string") {
          tempSingleStoryDetail.content = JSON.parse(tempSingleStoryDetail.content)
        }
        this.singleStoryDetail = tempSingleStoryDetail.data

        this.$store.dispatch('setLoading', false)
if (tempSingleStoryDetail==null){
  console.log('you do not have the correct credentials to view the story')
        this.$router.push({
          name: 'errorPage'
        })
}
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },
  },
  props: {
    singleStoryID: {
      type: Number,
      required: true
    },
  },
  components: {
    //singleStoryMapView,
    mediaFileStory,
    //singleStoryKGView,
    deleteEditStory
  },
  computed: {
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    accessToken: {
      get: function () {
        return this.$store.getters.getAccessToken;
      }
    }
  },

}
</script>
<style>
.placeNameSyle{
  text-decoration: underline;
  font-size: 0.8rem;
}
.btnStyle{
  color: #38737A;
  background-color: #E5FFFF;
}
.btnConnectedness{
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.titleStory{
  font-weight: bolder;
  font-size:1.2rem
}
.minheightcontent{
    min-height: 25vh;

}
.contentpreview > img{
  max-width: 100%;
}
table th {
    background-color: #e0e0e0;
    color: #000;
    text-align: left;
    vertical-align: bottom;
}
td{
  text-align: center;
  }
table td, table th {
    padding: .5em 1em;
}
table th {
    color: #000;
    text-align: left;
}
/*-----TODO RESOLVE PROBLEM v-card theme dark--- */
.theme--dark.v-image{
  color:black;
}
.v-card{
color:black;
}
.connectednessIcon{

  position: relative;
  top: 0rem;
  right: 0rem;
}
</style>